import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Carousels from './../Carousel/Carousel';
import WhatsNew from './../WhatsNew/WhatsNew';
import { setSelectedCover, setSelectedQuotedCover, showMobileProfile } from '../../actions/profileActions';
import GetCover from './../GetCover/GetCover';
import ProfileNavDesktop from '../ProfileNavigation/ProfileNavDesktop';
import Policy from '../Policies/Policy';
import LinkPolicy from '../LinkPolicy/LinkPolicy';
import SpecialDebitBanner from '../SpecialDebit/SpecialDebitBanner';
import { navigateTo } from '../../actions/navigationActions';
import SpecialDebitCard from '../SpecialDebit/SpecialDebitCard';
import { syncCoverWithProfile } from '../../actions/selfInspectActions';
import { showAddNewItem, showLinkPolicyModal, showModalRedirectToNam, showModalRedirectToZa } from '../../actions/modalActions';
import { setGuestData } from '../../actions/sspActions';
import { NAM_COUNTRY_ID_NUMBER, SA_COUNTRY_ID_NUMBER } from '../../constants/internationalization';
import { POLICY_COVER_ITEM, QUOTED_COVER_ITEM } from '../../constants/constants';
import './Dashboard.css';

class Dashboard extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            isMobile: false,
            reminderDismissed: false,
            updateReminderDismissed: false,
        };
        this.setIsMobile = this.setIsMobile.bind(this);
        this.handleSelfInspectionRequired = this.handleSelfInspectionRequired.bind(this);
        this.getSelfInspectionNoticeBanner = this.getSelfInspectionNoticeBanner.bind(this);
        this.getSelfInspectionItems = this.getSelfInspectionItems.bind(this);
    }

    checkCountryLogin() {
        var hostName = window.location.hostname;
        if ((this.props.profile.countryId === SA_COUNTRY_ID_NUMBER) && (hostName.includes(".co.na"))) {
            this.props.dispatchAction(showModalRedirectToZa())
        } else if ((this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER) && (hostName.includes(".co.za"))) {
            this.props.dispatchAction(showModalRedirectToNam())
        }
    }

    componentDidMount() {
        this.checkCountryLogin();
        this.setIsMobile();
        this.props.dispatchShowProfile();
        if (this.props.ssp.showLinkAuto && this.props.profile.policyNumber === "") {
            this.props.dispatchAction(showLinkPolicyModal())
            this.props.dispatchAction(setGuestData({ showLinkAuto: false }))
        }
        else {
            this.props.dispatchAction(setGuestData({ showLinkAuto: false }))
        }
        if (this.props.ssp.showSaleSelectAuto) {
            this.props.dispatchAction(showAddNewItem())
            this.props.dispatchAction(setGuestData({ showSaleSelectAuto: false }))
        }
    }

    async setIsMobile() {
        await this.setState({
            isMobile: window.innerWidth <= 1036,
        })
    }

    async dismissInspectionReminder() {

        await this.setState({
            reminderDismissed: !this.state.showMore
        })
    }

    async handleSelfInspectionRequired(coverItemType, coverId: any) {
        if (coverItemType === POLICY_COVER_ITEM) {
            await this.props.dispatchAction(setSelectedCover(coverId));
        }
        if (coverItemType === QUOTED_COVER_ITEM) {
            await this.props.dispatchAction(setSelectedQuotedCover(coverId));
        }
        await this.props.dispatchAction(syncCoverWithProfile());
    }

    getSelfInspectionNoticeBanner(coverItemType, riskItemId, description) {
        return <>
            <div className="Reminder-banner dashboard banner-padding mt-10px" onClick={() => this.handleSelfInspectionRequired(coverItemType, riskItemId)}>
                <div className="cursor-pointer row noma">
                    <div className="nopa mr-15px">
                        <img src="Images/White.svg" className="warning-icon-car" />
                    </div>
                    <div className="col nopa">
                        <p className="Monthly-mileage-update-car nomanopa">Self-inspection required for {description}. <Link onClick={() => this.handleSelfInspectionRequired(coverItemType, riskItemId)} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">Tap here.</Link></p>
                    </div>
                    <div className="Reminder-banner-close-img-col">
                        <img className="Reminder-banner-close-img-car" src="Images/icons-navigation-white.svg" alt="Dismiss" />
                    </div>
                </div>
            </div>
        </>
    }

    getSelfInspectionItems() {
        let items: any[] = [];
        const { profile } = this.props;
        if (profile.selectedPersonalPolicy != undefined && profile.selectedPersonalPolicy.covers?.length > 0) {
            var policy_item_inspections = profile.selectedPersonalPolicy.covers.filter(x => x.riskItems[0].inspectionRequired && x.isMainline == true)
            if (policy_item_inspections) {
                policy_item_inspections.forEach(item => {
                    items.push(this.getSelfInspectionNoticeBanner(POLICY_COVER_ITEM, item.id, item.riskItems[0].description));
                });
            }
        }
        if (profile.inspectionItems) {
            profile.inspectionItems.forEach(inspectionItem => {
                let quoteItem = profile.quotedFutureItems.filter(x => x.quoteRiskItem.quoteRiskItemLinkingId === inspectionItem.riskItemID);
                if (quoteItem.length > 0) {
                    items.push(this.getSelfInspectionNoticeBanner(QUOTED_COVER_ITEM, quoteItem[0].id, inspectionItem.description));
                }
            });
        }
        return items;
    }

    public render() {
        const { reminderDismissed } = this.state;
        const { profile } = this.props;
        window.addEventListener("resize", this.setIsMobile);

        let selfInspections = this.getSelfInspectionItems().map(item => {
            return item;
        });
        
        return (
            <>
                <div className="row on-top d-none Profile d-lg-block d-md-none">

                    <div id="profileFlex" className="flex-column">
                        <div className="col-12">
                            <ProfileNavDesktop />
                        </div>
                        <div className="col-12 pl-0">
                            <hr className="profile-divider" />
                        </div>
                        {(profile.isLinked) &&
                            <div className="col-12">
                                <Policy />
                            </div>
                        }
                        {(!profile.isLinked) &&
                            <>
                                <div className="col-12 row text-left">
                                    <p className="col-12 mb-0 ml-2">No. of policies</p>
                                    <h3 className="col-12 policies-active ml-2">None active</h3>
                                </div>
                                <div className="col-12">
                                    <LinkPolicy />
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div id="MainDashboard" className="profile-indent">
                    {this.props.profile.hasSpecialDebitDate &&
                        <>
                            <div className="col-12 d-none d-lg-block d-md-none">
                                {this.state.isMobile && (this.props.profile.specialDebitAmount ?? 0.00 != 0.00)  &&
                                    <>
                                        <SpecialDebitCard />
                                    </>
                                }
                                {!this.state.isMobile && (this.props.profile.specialDebitAmount ?? 0.00 != 0.00)  &&
                                    <>
                                        <SpecialDebitBanner />
                                    </>
                                }
                            </div>
                        </>
                    }
                    <div className="col-12">{selfInspections}</div>
                    <div className="col-12 d-none d-lg-block d-md-none">
                        <Carousels />
                    </div>
                    <div className="col-12 d-none d-xl-block">
                        {this.props.profile.isLinked &&
                            <div className="row ssp-dashboard-cards-container-row">
                                <div className="col-12 nopa">
                                    <WhatsNew />
                                </div>
                            </div>
                        }
                        {!this.props.profile.isLinked &&
                            <div className="row ssp-dashboard-cards-container-row">
                                {this.props.profile.countryId !== 157 &&
                                    <div className="col-lg-6 col-md-12 col-12 pl-5px">
                                        <WhatsNew />
                                    </div>
                                }
                                <div className="col-lg-6 col-md-12 col-12 nopa pl-15px">
                                    <GetCover />
                                </div>
                            </div>
                        }
                    </div>
                    <div className="d-none d-lg-block d-md-none d-xl-none">
                        <div className="col-12 nopa">
                            {this.props.profile.isLinked &&
                                <div className="col-12 ">
                                    <GetCover />
                                </div>
                            }
                            {this.props.profile.countryId !== 157 &&
                                <div className="col-12">
                                    <WhatsNew />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none">
                        <div className="col-12 pl-5px pr-10px">
                            <GetCover />
                        </div>
                        {this.props.profile.countryId !== 157 &&
                            <div className="col-12 pl-5px pr-10px">
                                <WhatsNew />
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowProfile: () => dispatch(showMobileProfile()),
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
